import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import attachmentsActions from 'actions/attachmentsActions'
import sectionsActions from 'actions/sections'

let select = state => ({
	attachBuffer: state.attachments
})

export class AttachButton extends Component{
	render(){
		let { props } = this
		return(
			<div className="button" style={props.style} >
				<span
					style={{
						cursor: "pointer"
					  , color: props.color || "#5ae4c3"
					}}
					onClick={()=> {
						this.refs["choose-attachment"].click(); props.SECTION_EXPAND({section: "attachments", expanded: true})
					}}
				>
					<i
						style={{
							fontSize:"22px"
						  , verticalAlign: "middle"
						  , marginRight: "5px"
						}}
						className="material-icons"
					>
						attach_file
					</i>
					<span style={{borderBottom: "dotted 2px #5ae4c3", display: (props.icon)?"none": ""}}>ATTACH</span>
				</span>
				<input
					type="file"
					style={{
						display: "none"
					}}
					key={(props.icon) ? `attach-${props.objectID}` : `attach-${props.objectID}-${Math.random()}`}
					id="fileInp"
					multiple={true}
					onChange={(evt) =>{
						let files = R.reject(x => x.size > 5e+7)(evt.target.files);
						if(Object.keys(files).length){
							props.ATTACHMENTS_ADD({objectID: props.objectID, url: props.path, files})
						}
					}}
					ref="choose-attachment"
				/>
			</div>
		)
	}
}
export default connect(select, {...attachmentsActions, ...sectionsActions})(AttachButton)



// WEBPACK FOOTER //
// ./src/components/Attachments/AttachButton.js